<template>
  <div>
    <Modal
      v-model="modalShow"
      :width="800"
      title="查看图片"
      :footer-hide="true"
    >
      <div class="image-cover">
        <Carousel
          v-if="showCarousel"
          v-model="swiperIndex"
          dots="none"
          :arrow="arrow"
          :height="height"
          loop
        >
          <CarouselItem v-for="(item, index) in imgList" :key="index">
            <div class="demo-carousel">
              <el-image
                style="width: 100%; height: 100%"
                :src="`${downloadUrl}?fileId=${item}`"
                :preview-src-list="srcLists"
                :fit="fit"
                @load="loadSuccess"
                @error="loadError"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>

              <!-- <img :src="`${downloadUrl}?fileId=${item}`" alt="" /> -->
            </div>
          </CarouselItem>
        </Carousel>
        <div v-if="height===0" class="placeholder-carousel">
          <Spin>
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            <div>加载中</div>
          </Spin>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    // 图片列表
    imgList: {
      type: Array,
      default: () => []
    },
    // 当前展示第几张图片
    pickIndex: {
      type: Number,
      default: 0
    },
    fit: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      showCarousel: false, // 走马灯初始化时不显示的解决方法
      modalShow: false,
      swiperIndex: 0,
      downloadUrl: '',
      height: 0,
      loadImgSuccess: 0
    };
  },
  computed: {
    arrow() {
      if (this.loadImgSuccess === this.imgList.length && this.imgList.length !== 0) {
        return this.imgList.length === 1 ? 'never' : 'always';
      } else {
        return 'never';
      }
    },
    srcLists() {
      const arr = [];
      this.imgList.forEach(item => {
        arr.push(`${this.downloadUrl}?fileId=${item}`);
      });
      return arr;
    }
  },
  watch: {
    pickIndex() {
      this.swiperIndex = this.pickIndex;
    },
    loadImgSuccess() {
      if (this.loadImgSuccess === this.imgList.length && this.imgList.length !== 0) {
        this.height = 'auto';
      }
    }

  },
  mounted() {
    this.getUrlToken();
  },
  methods: {
    loadSuccess() {
      this.loadImgSuccess++;
    },
    loadError() {
      this.loadImgSuccess++;
    },
    open() {
      this.modalShow = true;
      this.showCarousel = false;
      this.height = 0;
      this.loadImgSuccess = 0;
      if (this.pickIndex == 0) {
        this.swiperIndex = 0;
      }

      this.$nextTick(() => {
        this.showCarousel = true;
      });
    },
    // 上传token
    async getUrlToken() {
      const res = await this.$http.getUploadtoken();
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
        this.$emit('emitUrl', this.downloadUrl);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.image-cover {
  width: 700px;
  height: 700px;
  margin: 0 auto;
  // /deep/.ivu-carousel{
  //   height: 100%;
  // }
  // /deep/.ivu-carousel-list{
  //   height: 100%;
  // }
  // /deep/.ivu-carousel-item{
  //   height: 350px;
  // }
  .demo-carousel {
    width: 700px;
    height: 700px;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .placeholder-carousel{
    width: 700px;
    height: 700px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
   .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
}
</style>
